export default "__VITE_ASSET__9e7de683__"